<template>
  <a href="javascript:;" class="single-check-box">
    <em
      v-if="checkValue"
      class="checkbox-check"
      @click="updateValue(false)"
    ></em>
    <em v-else class="checkbox-uncheck" @click="updateValue(true)"></em>
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: 'SingleCheckbox',
  emits: ['update:value'],
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      checkValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.checkValue = newValue;
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update:value', value);
    }
  }
};
</script>

<style lang="scss">
.single-check-box {
  font-size: 18px;
  color: #474747;

  .checkbox-check,
  .checkbox-uncheck {
    display: inline-block;
    width: 28px;
    height: 27px;
    margin-top: -2px;
    margin-right: 4px;
    vertical-align: middle;
  }

  .checkbox-check {
    background: url('../../assets/image/passport/check.png') no-repeat
      center/contain;
  }

  .checkbox-uncheck {
    background: url('../../assets/image/passport/uncheck.png') no-repeat
      center/contain;
  }
}
.is-blancozone {
  .checkbox-check {
    background: url('../../assets/image/passport/blanco-check.png') no-repeat
      center/contain;
  }

  .checkbox-uncheck {
    background: url('../../assets/image/passport/blanco-uncheck.png') no-repeat
      center/contain;
  }
}
</style>
